import { Box, BoxProps } from '@chakra-ui/react';

export const BlueDiv: React.FC<BoxProps> = (props): JSX.Element => (
  <Box id="bluediv" {...props} />
);

BlueDiv.defaultProps = {
  bg: 'blue',
  bottom: 0,
  h: 0,
  position: 'absolute',
  w: 0,
};
